module.exports = __webpack_public_path__ + "files/92ead3146e3935dc0101fbad67dc5113.png";